export const orange = {
    orange100: '#fbf9f8',
    orange200: '#fef3ea',
    orange300: '#ffe9d2',
    orange400: '#ffd8ab',
    orange500: '#ffca90',
    orange600: '#ffbf85',
    orange700: '#efad73',
    orange800: '#e1964e',
    orange900: '#f79009',
    orange1000: '#eb8500',
    orange1100: '#b55e00',
    orange1200: '#513317',
    orangeAccentContrast: '#ffffff',
    orangeAccentSurface: '#fff5ea',
};

export const orangeAlpha = {
    orange100: 'rgba(201, 99, 48, 0.02)',
    orange200: 'rgba(255, 239, 225, 0.67)',
    orange300: '#ffe9d2',
    orange400: '#ffd8ab',
    orange500: '#ffca90',
    orange600: '#ffbf85',
    orange700: 'rgba(228, 107, 0, 0.55)',
    orange800: 'rgba(213, 105, 2, 0.69)',
    orange900: 'rgba(247, 140, 0, 0.96)',
    orange1000: '#eb8500',
    orange1100: '#b55e00',
    orange1200: 'rgba(64, 31, 0, 0.91)',
    orangeAccentContrast: '#ffffff',
    orangeAccentSurface: 'rgba(255, 243, 230, 0.8)',
};

export const orangeDark = {
    orange100: '#14100d',
    orange200: '#1d1610',
    orange300: '#331111',
    orange400: '#432300',
    orange500: '#512c03',
    orange600: '#603a13',
    orange700: '#764b21',
    orange800: '#98602a',
    orange900: '#f79009',
    orange1000: '#eb8500',
    orange1100: '#fda756',
    orange1200: '#fce0c8',
    orangeAccentContrast: '#ffffff',
    orangeAccentSurface: '#1d150f',
};

export const orangeDarkAlpha = {
    orange100: 'rgba(209, 0, 0, 0.02)',
    orange200: 'rgba(253, 116, 0, 0.05)',
    orange300: 'rgba(251, 119, 0, 0.14)',
    orange400: 'rgba(254, 103, 0, 0.21)',
    orange500: 'rgba(254, 117, 0, 0.27)',
    orange600: 'rgba(255, 140, 23, 0.33)',
    orange700: 'rgba(253, 153, 54, 0.43)',
    orange800: 'rgba(255, 156, 61, 0.59)',
    orange900: 'rgba(254, 148, 9, 0.99)',
    orange1000: 'rgba(255, 144, 0, 0.92)',
    orange1100: 'rgba(255, 168, 87, 0.99)',
    orange1200: 'rgba(255, 233, 202, 0.99)',
    orangeAccentContrast: '#ffffff',
    orangeAccentSurface: 'rgba(40, 25, 14, 0.5)',
};
